module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0006.03102cf5.jpg";